import { useMutation } from "react-query";
import { deleteJobs } from "../../../../actions/Utilities/JobConfig";
const useDeactivateJobs = () => {
  return useMutation(deleteJobs);
};

export default useDeactivateJobs;
